"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentActivity = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var _1 = require(".");
var RecentActivity = function () {
    var recentActivities = [
        {
            userName: 'Sam McDonough',
            title: 'broker',
            message: 'ABC Company application has been approved.',
            time: '32min ago',
            date: '',
            action: { text: 'Quite is ready to send to client', link: '#' },
            messageType: 'info',
        },
        {
            userName: 'Sam McDonough',
            title: 'broker',
            message: '$4564 commisions has been deposited.',
            time: '11:52 AM',
            date: 'Yesterday',
            action: {},
            messageType: 'info',
        },
        {
            userName: 'Akiva Brulen',
            title: 'Client',
            message: 'New issues detected',
            time: '7:33 PM',
            date: 'Apr 15th, 2021',
            action: {},
            messageType: 'warning',
        },
        {
            userName: 'Sam McDonough',
            title: 'broker',
            message: '$9753 commisions has been deposited.',
            time: '7:00 AM',
            date: 'Apr 14th, 2021',
            action: {},
            messageType: 'info',
        },
        {
            userName: 'Sam McDonough',
            title: 'broker',
            message: '$9753 commisions has been deposited.',
            time: '7:00 AM',
            date: 'Apr 14th, 2021',
            action: {},
            messageType: 'info',
        },
        {
            userName: 'Sam McDonough',
            title: 'broker',
            message: '$9753 commisions has been deposited.',
            time: '7:00 AM',
            date: 'Apr 14th, 2021',
            action: {},
            messageType: 'info',
        },
    ];
    return ((0, jsx_runtime_1.jsx)(_1.Card, __assign({ sx: { height: '100%' } }, { children: (0, jsx_runtime_1.jsx)(_1.CardContent, __assign({ sx: {
                display: 'flex',
                alignItems: 'center',
                paddingY: '2.8rem',
                color: 'primary.400',
            } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", spacing: "2.8rem", sx: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: {
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodyLarge", sx: {
                                    fontWeight: '700',
                                    fontStyle: 'normal',
                                    lineHeight: '2.7rem',
                                    color: 'primary.600',
                                } }, { children: "Recent Activity" })), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ href: "#" }, { children: "View more activity" }))] })), (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "column", spacing: "3.2rem", sx: {
                            '&:before': {
                                content: '""',
                                height: '90%',
                                width: '0.4rem',
                                backgroundColor: 'primary.200',
                                top: '1rem',
                                left: '1.9rem',
                                position: 'absolute',
                            },
                            width: '100%',
                            position: 'relative',
                        } }, { children: recentActivities.map(function (activity, i) {
                            return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: {
                                    width: '100%',
                                    alignItems: 'flex-start',
                                    justifyContent: 'space-between',
                                } }, { children: [(0, jsx_runtime_1.jsx)(_1.UserActivity, { userName: activity.userName, title: activity.title, message: activity.message, action: activity.action, messageType: activity.messageType }), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", sx: { width: '16.2rem', alignItems: 'end' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: activity === null || activity === void 0 ? void 0 : activity.date }), (0, jsx_runtime_1.jsx)(material_1.Typography, { children: activity.time })] }))] }), i));
                        }) }))] })) })) })));
};
exports.RecentActivity = RecentActivity;
